//import { ConfigTopNode } from '../../types'

/* eslint-disable no-unused-vars */
export default {
  buildRecursiveVPSetParameter(vpSetChildren: Array<Object>, level: number) {
    let vPSetParameterText = ''
    let tab = '&emsp;'

    if (JSON.stringify(vpSetChildren) != '[{}]') {
      vPSetParameterText += '</br>'
    }

    for (const [key, vpSetChildObject] of Object.entries(vpSetChildren)) {
      /*   console.log('vpSetChildObject KEY: ' + key)
      console.log('vpSetChildObject VALUE: ' + JSON.stringify(vpSetChildObject))
      console.log('vpSetChildObject NAME: ' + vpSetChildObject['name']) */
      if (vpSetChildObject['name'] == 'PSet') {
        //if (paramCounter == 0) {
        vPSetParameterText += tab.repeat(level) + 'cms.PSet(' //nested no named PSet
        level++
        vPSetParameterText += tab.repeat(level)

        vPSetParameterText += this.buildRecursiveVPSetParameter(
          vpSetChildObject['children'],
          level
        )
        level--
      } else {
        vPSetParameterText += tab.repeat(level)

        if (
          vpSetChildObject['type'] != 'cms.VPSet' &&
          vpSetChildObject['type'] != 'cms.VPSet' &&
          vpSetChildObject['type'] != 'cms.untracked.PSet' &&
          vpSetChildObject['type'] != 'cms.untracked.VPSet'
        )
          vPSetParameterText += vpSetChildObject['name']
        else vPSetParameterText += vpSetChildObject['name'] + ' = '

        vPSetParameterText += vpSetChildObject['type'] + '( '
        if (
          vpSetChildObject['type'] != 'cms.PSet' &&
          vpSetChildObject['type'] != 'cms.VPSet' &&
          vpSetChildObject['type'] != 'cms.untracked.PSet' &&
          vpSetChildObject['type'] != 'cms.untracked.VPSet'
        ) {
          vPSetParameterText +=
            JSON.stringify(vpSetChildObject['paremeterJSONValue'], null, ' ') +
            ' )</br>'
        } else {
          //complicated set type needs deconstructing
          vPSetParameterText += this.buildRecursiveVPSetParameter(
            vpSetChildObject['children'],
            level + 1
          )
        }
      }
    }

    vPSetParameterText += tab.repeat(level - 1) + ')' + '</br>'
    return vPSetParameterText
  },
  getModuleSnippet(
    moduleName: string,
    ctype: string,
    pytype: string,
    moduleChildrenIds: Array<any>,
    configNodesMap: Object
  ) {
    let moduleSnippet = moduleName + ' = '
    let innerParameterText = ''
    let cType = ''

    let moduleChildrenArray: Array<Object> = []
    //form module children array
    for (let i = 0; i < moduleChildrenIds.length; i++) {
      moduleChildrenArray.push(configNodesMap[moduleChildrenIds[i]])
    }

    moduleSnippet += 'cms.' + pytype + '( '
    cType = '"' + ctype + '",</br>'
    for (const [key, childObject] of Object.entries(moduleChildrenArray)) {
      if (
        childObject['type'] == 'cms.PSet' ||
        childObject['type'] == 'cms.VPSet' ||
        childObject['type'] == 'cms.untracked.PSet' ||
        childObject['type'] == 'cms.untracked.VPSet'
      ) {
        innerParameterText += '&emsp;' + childObject['name'] + ' = ' //parameter name
      } else {
        innerParameterText += '&emsp;' + childObject['name']
      }

      innerParameterText += childObject['type'] + '( '
      if (
        childObject['type'] != 'cms.PSet' &&
        childObject['type'] != 'cms.VPSet' &&
        childObject['type'] != 'cms.untracked.PSet' &&
        childObject['type'] != 'cms.untracked.VPSet'
      ) {
        innerParameterText +=
          JSON.stringify(childObject['paremeterJSONValue'], null, ' ') +
          ' )</br>'
      } else {
        //complicated set type needs deconstructing
        innerParameterText += this.buildRecursiveVPSetParameter(
          childObject['children'],
          2
        )
      }
    }
    moduleSnippet = moduleSnippet + cType + innerParameterText
    moduleSnippet += ' )'

    return moduleSnippet
  },
  getESProducerSnippet(
    esProducerName: string,
    ctype: string,
    pytype: string,
    esProducerChildren: Array<Object>
  ) {
    let esProducerSnippet = esProducerName + ' = '
    let innerParameterText = ''
    let cType = ''

    esProducerSnippet += 'cms.' + pytype + '( '
    cType = '"' + ctype + '",</br>'
    for (const [key, childObject] of Object.entries(esProducerChildren)) {
      if (
        childObject['type'] == 'cms.PSet' ||
        childObject['type'] == 'cms.VPSet' ||
        childObject['type'] == 'cms.untracked.PSet' ||
        childObject['type'] == 'cms.untracked.VPSet'
      ) {
        innerParameterText += '&emsp;' + childObject['name'] + ' = ' //parameter name
      } else {
        innerParameterText += '&emsp;' + childObject['name']
      }

      innerParameterText += childObject['type'] + '( '
      if (
        childObject['type'] != 'cms.PSet' &&
        childObject['type'] != 'cms.VPSet' &&
        childObject['type'] != 'cms.untracked.PSet' &&
        childObject['type'] != 'cms.untracked.VPSet'
      ) {
        innerParameterText +=
          JSON.stringify(childObject['paremeterJSONValue'], null, ' ') +
          ' )</br>'
      } else {
        //complicated set type needs deconstructing
        innerParameterText += this.buildRecursiveVPSetParameter(
          childObject['children'],
          2
        )
      }
    }
    esProducerSnippet = esProducerSnippet + cType + innerParameterText
    esProducerSnippet += ' )'

    return esProducerSnippet
  },
  getESSourceSnippet(
    esSourceName: string,
    ctype: string,
    pytype: string,
    esSourceChildren: Array<Object>
  ) {
    let esSourceSnippet = esSourceName + ' = '
    let innerParameterText = ''
    let cType = ''

    esSourceSnippet += 'cms.' + pytype + '( '
    cType = '"' + ctype + '",</br>'
    for (const [key, childObject] of Object.entries(esSourceChildren)) {
      if (
        childObject['type'] == 'cms.PSet' ||
        childObject['type'] == 'cms.VPSet' ||
        childObject['type'] == 'cms.untracked.PSet' ||
        childObject['type'] == 'cms.untracked.VPSet'
      ) {
        innerParameterText += '&emsp;' + childObject['name'] + ' = ' //parameter name
      } else {
        innerParameterText += '&emsp;' + childObject['name']
      }

      innerParameterText += childObject['type'] + '( '
      if (
        childObject['type'] != 'cms.PSet' &&
        childObject['type'] != 'cms.VPSet' &&
        childObject['type'] != 'cms.untracked.PSet' &&
        childObject['type'] != 'cms.untracked.VPSet'
      ) {
        innerParameterText +=
          JSON.stringify(childObject['paremeterJSONValue'], null, ' ') +
          ' )</br>'
      } else {
        //complicated set type needs deconstructing
        innerParameterText += this.buildRecursiveVPSetParameter(
          childObject['children'],
          2
        )
      }
    }
    esSourceSnippet = esSourceSnippet + cType + innerParameterText
    esSourceSnippet += ' )'

    return esSourceSnippet
  },
  getServiceSnippet(
    serviceName: string,
    ctype: string,
    pytype: string,
    serviceChildren: Array<Object>
  ) {
    let servicceSnippet = serviceName + ' = '
    let innerParameterText = ''
    let cType = ''

    servicceSnippet += 'cms.' + pytype + '( '
    cType = '"' + ctype + '",</br>'
    for (const [key, childObject] of Object.entries(serviceChildren)) {
      if (
        childObject['type'] == 'cms.PSet' ||
        childObject['type'] == 'cms.VPSet' ||
        childObject['type'] == 'cms.untracked.PSet' ||
        childObject['type'] == 'cms.untracked.VPSet'
      ) {
        innerParameterText += '&emsp;' + childObject['name'] + ' = ' //parameter name
      } else {
        innerParameterText += '&emsp;' + childObject['name']
      }

      innerParameterText += childObject['type'] + '( '
      if (
        childObject['type'] != 'cms.PSet' &&
        childObject['type'] != 'cms.VPSet' &&
        childObject['type'] != 'cms.untracked.PSet' &&
        childObject['type'] != 'cms.untracked.VPSet'
      ) {
        innerParameterText +=
          JSON.stringify(childObject['paremeterJSONValue'], null, ' ') +
          ' )</br>'
      } else {
        //complicated set type needs deconstructing
        innerParameterText += this.buildRecursiveVPSetParameter(
          childObject['children'],
          2
        )
      }
    }
    servicceSnippet = servicceSnippet + cType + innerParameterText
    servicceSnippet += ' )'

    return servicceSnippet
  },
  getPathSnippet(pathName: string, pathChildren: Array<Object>) {
    //console.log(path)
    //console.log(pathChildren)
    //console.log('getPathSnippet CALLED!')
    let pathSnippet = pathName + ' = cms.Path('
    pathChildren.forEach((val, key, pathChildren) => {
      if (Object.is(pathChildren.length - 1, key)) {
        pathSnippet += ' ' + val['name'] + ' )'
      } else {
        pathSnippet += ' ' + val['name'] + ' + '
      }
    })
    //console.log(pathSnippet)
    return pathSnippet
    //return JSON.stringify(pathChildren)
  },
  getEndPathSnippet(endPathName: string, endPathChildren: Array<Object>) {
    //console.log(path)
    //console.log(endPathChildren)
    //console.log('getPathSnippet CALLED!')
    let endPathSnippet = endPathName + ' = cms.EndPath('
    endPathChildren.forEach((val, key, endPathChildren) => {
      if (Object.is(endPathChildren.length - 1, key)) {
        endPathSnippet += ' ' + val['name'] + ' )'
      } else {
        endPathSnippet += ' ' + val['name'] + ' + '
      }
    })
    //console.log(endPathSnippet)
    return endPathSnippet
    //return JSON.stringify(endPathChildren)
  },
  getSequenceSnippet(sequenceName: string, sequenceChildren: Array<Object>) {
    //console.log(sequenceChildren)
    //console.log('getSequenceSnippet CALLED!')
    let sequenceSnippet = sequenceName + ' = cms.Sequence('
    if (sequenceChildren.length == 0) sequenceSnippet += ')'
    else
      sequenceChildren.forEach((val, key, sequenceChildren) => {
        /*   console.log('VAL: ' + JSON.stringify(val))
        console.log('KEY: ' + key) */
        if (Object.is(sequenceChildren.length - 1, key)) {
          sequenceSnippet += ' ' + val['name'] + ' )'
        } else {
          sequenceSnippet += ' ' + val['name'] + ' + '
        }
      })
    return sequenceSnippet
    //return JSON.stringify(sequenceChildren)
  },
  getTaskSnippet(taskName: string, taskChildren: Array<Object>) {
    //console.log(taskChildren)
    //console.log('getTaskSnippet CALLED!')
    let taskSnippet = taskName + ' = cms.Task('
    if (taskChildren.length == 0) taskSnippet += ')'
    else
      taskChildren.forEach((val, key, taskChildren) => {
        /*   console.log('VAL: ' + JSON.stringify(val))
        console.log('KEY: ' + key) */
        if (Object.is(taskChildren.length - 1, key)) {
          taskSnippet += ' ' + val['name'] + ' )'
        } else {
          taskSnippet += ' ' + val['name'] + ' + '
        }
      })
    return taskSnippet
    //return JSON.stringify(taskChildren)
  },  
  getCondTaskSnippet(taskName: string, taskChildren: Array<Object>) {
    //console.log(taskChildren)
    //console.log('getTaskSnippet CALLED!')
    let taskSnippet = taskName + ' = cms.ConditionalTask('
    if (taskChildren.length == 0) taskSnippet += ')'
    else
      taskChildren.forEach((val, key, taskChildren) => {
        /*   console.log('VAL: ' + JSON.stringify(val))
        console.log('KEY: ' + key) */
        if (Object.is(taskChildren.length - 1, key)) {
          taskSnippet += ' ' + val['name'] + ' )'
        } else {
          taskSnippet += ' ' + val['name'] + ' + '
        }
      })
    return taskSnippet
    //return JSON.stringify(taskChildren)
  },
  getPSetSnippet(psetName: string, psetChildren: Array<Object>) {
    let psetSnippet = psetName + ' = '
    let innerParameterText = ''
    let cType = 'cms.PSet(</br>'

    for (const [key, childObject] of Object.entries(psetChildren)) {
      /*     console.log('KEY1: ' + key)
      console.log('VALUE1: ' + childObject) */
      //innerParameterText += '&emsp;' + key + ' = ' //parameter name

      if (
        childObject['type'] == 'cms.PSet' ||
        childObject['type'] == 'cms.VPSet' ||
        childObject['type'] == 'cms.untracked.PSet' ||
        childObject['type'] == 'cms.untracked.VPSet'
      ) {
        innerParameterText += '&emsp;' + childObject['name'] + ' = ' //parameter name
      } else {
        innerParameterText += '&emsp;' + childObject['name']
      }

      innerParameterText += childObject['type'] + '( '
      if (
        childObject['type'] != 'cms.PSet' &&
        childObject['type'] != 'cms.VPSet' &&
        childObject['type'] != 'cms.untracked.PSet' &&
        childObject['type'] != 'cms.untracked.VPSet'
      ) {
        innerParameterText +=
          JSON.stringify(childObject['paremeterJSONValue'], null, ' ') +
          ' )</br>'
      } else {
        //complicated set type needs deconstructing
        innerParameterText += this.buildRecursiveVPSetParameter(
          childObject['children'],
          2
        )
      }
    }
    psetSnippet = psetSnippet + cType + innerParameterText
    psetSnippet += ' )'

    return psetSnippet
  },
  getSwitchProducerSnippet(
    spName: string,
    ctype: string,
    pytype: string,
    spChildren: Array<Object>
  ) {
    /*     console.log('spName: ' + spName)
    console.log('ctype: ' + ctype)
    console.log('pytype: ' + pytype)
    console.log('children: ' + spChildren) */
    //console.log('ctype: ' + ctype)
    let spSnippet = spName + ' = ' + pytype
    let innerParameterText = '' //console.log('SP: ' + spSnippet)
    /*     let cType = ''
     */ spSnippet += '(</br>'
    //cType = '"' + ctype + '",</br>'
    for (const [key, childObject] of Object.entries(spChildren)) {
      for (const [key1, childObject1] of Object.entries(childObject)) {
        /*       console.log('KEY: ' + key1)
        console.log('VALUE: ' + JSON.stringify(childObject1)) */
        if (key1 == 'name') {
          spSnippet += '&emsp;' + childObject1 + ' = '
        } else if (key1 == 'children') {
          //console.log('childObject1['name']:' + childObject1[0]['name'])
          if (childObject1[0]['name'] == 'EDAlias') {
            spSnippet += 'cms.EDAlias(</br>'
          } else {
            spSnippet += 'cms.EDProducer("' + childObject1[0]['name'] + '"</br>'
          }
          /*        console.log(
            'childObject1[0]['children']['type']: ' + childObject1[0]['children']['type']
          ) */
          innerParameterText = ''
          for (const [key2, childObject2] of Object.entries(
            childObject1[0]['children'] as Array<Object>
          )) {
            if (
              childObject2['type'] == 'cms.PSet' ||
              childObject2['type'] == 'cms.VPSet' ||
              childObject2['type'] == 'cms.untracked.PSet' ||
              childObject2['type'] == 'cms.untracked.VPSet'
            ) {
              innerParameterText +=
                '&emsp;' + '&emsp;' + childObject2['name'] + ' = ' //parameter name
            } else {
              innerParameterText += '&emsp;' + '&emsp;' + childObject2['name']
            }

            innerParameterText += childObject2['type'] + '( '
            if (
              childObject2['type'] != 'cms.PSet' &&
              childObject2['type'] != 'cms.VPSet' &&
              childObject2['type'] != 'cms.untracked.PSet' &&
              childObject2['type'] != 'cms.untracked.VPSet'
            ) {
              innerParameterText +=
                JSON.stringify(childObject2['paremeterJSONValue'], null, ' ') +
                ' )</br>'
            } else {
              //complicated set type needs deconstructing
              innerParameterText += this.buildRecursiveVPSetParameter(
                childObject2['children'],
                3
              )
            }
          }
          spSnippet = spSnippet + innerParameterText + '&emsp;)</br>'
        }
      }
    }
    spSnippet += ' )'

    return spSnippet
  },
  getCPUSnippet(
    cpuName: string,
    ctype: string,
    pytype: string,
    cpuChildren: Array<Object>
  ) {
    /*     console.log('cpuName: ' + cpuName)
    console.log('ctype: ' + ctype)
    console.log('pytype: ' + pytype)
    console.log('children: ' + JSON.stringify(cpuChildren)) */
    let spSnippet = cpuName + ' = '
    let innerParameterText = ''
    /*     console.log('cpuChildren[0]['name']: ' + cpuChildren[0]['name'])
     */
    if (cpuChildren[0]['name'] == 'EDAlias')
      spSnippet += 'cms.' + cpuChildren[0]['name'] + '(</br>'
    else spSnippet += 'cms.EDProducer("' + cpuChildren[0]['name'] + '"</br>'

    for (const [key2, childObject2] of Object.entries(
      cpuChildren[0]['children'] as Array<Object>
    )) {
      if (
        childObject2['type'] == 'cms.PSet' ||
        childObject2['type'] == 'cms.VPSet' ||
        childObject2['type'] == 'cms.untracked.PSet' ||
        childObject2['type'] == 'cms.untracked.VPSet'
      ) {
        innerParameterText += '&emsp;' + '&emsp;' + childObject2['name'] + ' = ' //parameter name
      } else {
        innerParameterText += '&emsp;' + '&emsp;' + childObject2['name']
      }

      innerParameterText += childObject2['type'] + '( '
      if (
        childObject2['type'] != 'cms.PSet' &&
        childObject2['type'] != 'cms.VPSet' &&
        childObject2['type'] != 'cms.untracked.PSet' &&
        childObject2['type'] != 'cms.untracked.VPSet'
      ) {
        innerParameterText +=
          JSON.stringify(childObject2['paremeterJSONValue'], null, ' ') +
          ' )</br>'
      } else {
        //complicated set type needs deconstructing
        innerParameterText += this.buildRecursiveVPSetParameter(
          childObject2['children'],
          3
        )
      }
    }
    spSnippet = spSnippet + innerParameterText + '&emsp;)</br>  )'
    return spSnippet
  },
}
